import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowBorder } from "../../../assets/arrow-border";
import { BasketIcon } from "../../../assets/basket-icon";
import styles from "./basket-navigation.module.css";
export const BasketIconWrapper = ()=>/*#__PURE__*/ _jsxs("div", {
        className: styles.basketIconsContainer,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.basketIcon,
                children: /*#__PURE__*/ _jsx(BasketIcon, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.arrowBorder,
                children: /*#__PURE__*/ _jsx(ArrowBorder, {})
            })
        ]
    });
